import { setIn, setAllIn } from 'utils/immutable'
import * as actions from 'actions/feature/queries'

const pathToQueries = ['currentFeature', 'queries']

export default {
  [actions.SET_QUERY_EVALUATION]: updateQueryEvaluation,
  [actions.SET_QUERY_FIELD]: updateQueryField,
  [actions.RESET_CONDITION_FLOATING_CIRCUITS]: resetFloatingCircuits, // TODO: move to conditions
}

function updateQueryEvaluation(state, { queryUri, queryLabel, value }) {
  return setIn([...pathToQueries, queryUri, queryLabel], value)(state)
}

function updateQueryField(state, { queryUri, paramName, value }) {
  const pathToField = [...pathToQueries, queryUri, paramName]
  return setIn(pathToField, value)(state)
}

const pathToFloatingCircuit = (uri) => [
  'currentFeature',
  'outputs',
  uri,
  'floatingCircuit',
]

function resetFloatingCircuits(state, { uris }) {
  return setAllIn(uris, pathToFloatingCircuit, null, state)
}
